import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { ApiProvider } from "../ApiProvider";
import { EventInventoryRecord } from "@src/store/pricing/queryEventInventoryAllSlice";

export interface ICreateInvoiceParams {
	pricePerTicket: number;
	CustCompanyName: string;
	CompanyName: string;
	CustomerId: number;
	Complete: boolean;
	ShippingNotes: string;
	BuyerPoId: string;
	Items: Array<EventInventoryRecord>;
	IsExchange: boolean;
}

export interface ICreateInvoiceResponse {
	success?: boolean;
	invoiceId?: number;
}

type TState = {
	loading: boolean;
	error: string | null;
};

const initialState: TState = {
	loading: false,
	error: null,
};

export const createInvoice = createAsyncThunk<ICreateInvoiceResponse, ICreateInvoiceParams>(
	"sales/createInvoice",
	async (params, { rejectWithValue }) => {
		try {
			return await ApiProvider.default.post<ICreateInvoiceResponse>("/api/Sales/CreateInvoice", params);
		} catch (error) {
			if (error instanceof AxiosError) return rejectWithValue(error.message);
			return rejectWithValue("Unknown error");
		}
	},
);

export const createInvoiceSlice = createSlice({
	name: "sales/createInvoice",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(createInvoice.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(createInvoice.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(createInvoice.rejected, (state, action) => {
				state.loading = false;
				state.error = (action.payload as string) ?? null;
			});
	},
});
